/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// vue 2
// window.Vue = require('vue').default;
// 改為 vue 3
window.Vue = require('vue');

/*
const app = new Vue({
    el: '#app',
});
*/
import mitt from "mitt";
// import Swal from 'sweetalert2';
window.Swal = require('sweetalert2');

// vue 3
$( function() {
    const eventBus = mitt();
    const app = Vue.createApp({});
    app.component('menu-cart', Vue.defineAsyncComponent(() => import(/* webpackChunkName:'menu-cart' */ './components/MenuCartComponent.vue')));
    app.component('cart-page', Vue.defineAsyncComponent(() => import(/* webpackChunkName:'cart-page' */ './Pages/Cart.vue')));
    app.component('cart-add', Vue.defineAsyncComponent(() => import(/* webpackChunkName:'cart-add' */ './Pages/CartAdd.vue')));
    app.component('order-step1', Vue.defineAsyncComponent(() => import(/* webpackChunkName:'order-step1' */ './Pages/OrderStep1.vue')));
    // app.component('pay',       Vue.defineAsyncComponent(() => import(/* webpackChunkName:'pay' */ './Pages/Pay.vue')));
    
    // 把 mitt 加入 Vue 的全域 Property，讓任何一個元件都能使用
    app.config.globalProperties.eventBus = eventBus;
    app.mount("#app");
});
